export const reviewGridColumns = [
    'number','creationDate','serviceType','taskId','store', 'reviewDate', 'rating',
    'review'
  ]

export const praxisReviewGridColumns = [
    'number','creationDate','serviceType','taskId', 'reviewDate', 'rating',
    'review'
  ]